<template>
    <div>
        <component
            v-if="cType && cId"
            :ref="setVueRefs"
            :is="cType"
            :c-id="cId"
            v-bind="passedProps"
        ></component>
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { store } from "@common/store/store";
import { errorHandler } from "@common/errorHandler/errorHandler";
import "@common/syncfusionCss";

let inlineComponents = [];

const adapterComponentComp = {
    name: 'adapterComponent',
    props: {
        cId: {
            default: false
        },
        cType: {
            default: false
        }
    },
    data() {
        return {
            vueData: {}
        };
    },
    computed: {
        passedProps() {
            let passedProps = {};
            for (let propName in this.$attrs) {
                if (propName === 'length') continue;
                let isContext = propName.indexOf('context-') === 0;
                let propVal = isContext
                    ? !isNaN(this.$attrs[propName]) && Number(this.$attrs[propName])
                    : this.$attrs[propName];
                passedProps['prop-' + propName] = propVal;
                passedProps[propName] = propVal;
            }
            return passedProps;
        }
    },
    mounted() {
        // TODO: Where does the incoming data go?  Through a datamapper?
        let elemId = this.$attrs.id;
        document.addEventListener(elemId + '_ngDataToVue', (e) => {
            if (e.detail !== this.vueData) {
                this.vueData = e.detail;
            }
        });
    },
    methods: {
        setVueRefs(el) {
            if (el && this.cType === 'pdf') {
                if (typeof window.vueRefs === 'undefined') window.vueRefs = [];
                window.vueRefs[this.cId] = el;
            }
        }
    },
    watch: {
        vueData(oldValue, newValue) {
            // Send data to NG component
            let elemId = this.$attrs.id;
            let vueDataEvent = new CustomEvent(elemId + '_vueDataToNg', { detail: newValue });
            document.dispatchEvent(vueDataEvent);
        }
    },
    components: {
        store,
        errorHandler,
        layoutContainer: defineAsyncComponent(() => import('@common/layoutContainer/layoutContainer.vue'))
    }
};

window.adapterComponentComp = adapterComponentComp;
export default adapterComponentComp;
</script>

<style lang="css" scoped>
@import "~@common/global.css";
@import "~@assets/css/utilities.css";
</style>
